import { getLocalStore, setLocalStore } from 'shared/lib/local-store.ts'
import { PagesModule } from 'shared/ui/tabs-pages'

export const sessionKey = 'pageModule'

export const tabsChangeSession = () => {
  const setPageModule = (key: string) => {
    setLocalStore(sessionKey, key)
  }

  const getPageModule = () => {
    const result = getLocalStore(sessionKey) || 'avia'

    return result as PagesModule
  }

  return {
    setPageModule,
    getPageModule,
  }
}
